import { render, staticRenderFns } from "./overseasGoodsDetail.vue?vue&type=template&id=46064db2&scoped=true&"
import script from "./overseasGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./overseasGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./overseasGoodsDetail.vue?vue&type=style&index=0&id=46064db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46064db2",
  null
  
)

component.options.__file = "overseasGoodsDetail.vue"
export default component.exports